import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import {
  DocumentResourcePayload,
  setDocumentResources,
  updateDocResource,
} from 'data/documents';

function* updateDocResourceManager(
  action: PayloadAction<DocumentResourcePayload>,
) {
  const { payload } = action;

  try {
    yield put(setDocumentResources(payload.resourceSections));
    yield DocumentsAPI.updateDocumentResources(payload);
  } catch (e) {
    // TODO: handle error
  }
}
export const watchUpdateDocResourceSections = function* () {
  yield takeLatest(updateDocResource.type, updateDocResourceManager);
};
